<div [formGroup]="parentForm" class="select-field" [ngStyle]="{'min-width': minWidth ? minWidth : 'auto', 'max-width': maxWidth ? maxWidth : 'none'}">
  <mat-select (selectionChange)="onValueChanged($event)" [formControlName]="controlName"
              [multiple]="false"
              [placeholder]="inputPlaceholder" panelClass="visits-caregiver-travelling hide-checkbox">
    <mat-option *ngFor="let item of items" [value]="item.value">
      {{ item.text }}
    </mat-option>
  </mat-select>
</div>
